import { getAchievement } from '../../../shared/achievements';
import { useTranslation } from 'react-i18next';
import { getAchievementDescription, getAchievementTitle } from '../../utils/i18nHelpers';

function AchievementCard({ achievementId, unlocked, unlockedAt, currentValue, creditsAwarded }) {
  const { t } = useTranslation();
  const def = getAchievement(achievementId);
  if (!def) return null;

  const threshold = def.threshold ?? 1;
  const progress = Math.min((currentValue ?? 0) / threshold, 1);
  const remaining = Math.max(threshold - (currentValue ?? 0), 0);

  return (
    <div className={`ach-card ${unlocked ? 'ach-card--unlocked' : 'ach-card--locked'}`}>
      <div className="ach-card__top">
        <span className="ach-card__icon">{def.icon}</span>
        <div className="ach-card__info">
          <span className="ach-card__title">{getAchievementTitle(t, achievementId, def.title)}</span>
          <span className="ach-card__desc">{getAchievementDescription(t, achievementId, def.description)}</span>
        </div>
        <span className="ach-card__credits">+{def.credits}</span>
      </div>
      {unlocked ? (
        <div className="ach-card__unlocked-row">
          <span className="ach-card__pill">{t('achievements.unlocked')}</span>
          {unlockedAt && (
            <span className="ach-card__date">{new Date(unlockedAt).toLocaleDateString()}</span>
          )}
        </div>
      ) : (
        <div className="ach-card__progress">
          <div className="ach-card__bar">
            <div className="ach-card__fill" style={{ width: `${progress * 100}%` }} />
          </div>
          <span className="ach-card__remaining">
            {def.category === 'volume'
              ? t('achievements.remainingWords', { count: remaining })
              : t('achievements.remainingMore', { count: remaining })}
          </span>
        </div>
      )}
    </div>
  );
}

export default AchievementCard;
